export const REQUEST_LOAD_ITEM: 'OPTIONAL_PROGRAM_ITEM/REQUEST_ITEM' = 'OPTIONAL_PROGRAM_ITEM/REQUEST_ITEM';
export const REQUEST_LOAD_ITEM_SUCCESS: 'OPTIONAL_PROGRAM_ITEM/REQUEST_ITEM_SUCCESS' =
	'OPTIONAL_PROGRAM_ITEM/REQUEST_ITEM_SUCCESS';
export const REQUEST_LOAD_ITEM_FAILURE: 'OPTIONAL_PROGRAM_ITEM/REQUEST_ITEM_FAILURE' =
	'OPTIONAL_PROGRAM_ITEM/REQUEST_ITEM_FAILURE';
export const REQUEST_CREATE_ITEM: 'OPTIONAL_PROGRAM_ITEM/REQUEST_CREATE_ITEM' =
	'OPTIONAL_PROGRAM_ITEM/REQUEST_CREATE_ITEM';
export const REQUEST_CREATE_ITEM_SUCCESS: 'OPTIONAL_PROGRAM_ITEM/REQUEST_CREATE_ITEM_SUCCESS' =
	'OPTIONAL_PROGRAM_ITEM/REQUEST_CREATE_ITEM_SUCCESS';
export const REQUEST_CREATE_ITEM_FAILURE: 'OPTIONAL_PROGRAM_ITEM/REQUEST_CREATE_ITEM_FAILURE' =
	'OPTIONAL_PROGRAM_ITEM/REQUEST_CREATE_ITEM_FAILURE';
export const REQUEST_CREATE_CUSTOM: 'OPTIONAL_PROGRAM_ITEM/REQUEST_CREATE_CUSTOM' =
	'OPTIONAL_PROGRAM_ITEM/REQUEST_CREATE_CUSTOM';
export const REQUEST_CREATE_CUSTOM_SUCCESS: 'OPTIONAL_PROGRAM_ITEM/REQUEST_CREATE_CUSTOM_SUCCESS' =
	'OPTIONAL_PROGRAM_ITEM/REQUEST_CREATE_CUSTOM_SUCCESS';
export const REQUEST_CREATE_CUSTOM_FAILURE: 'OPTIONAL_PROGRAM_ITEM/REQUEST_CREATE_CUSTOM_FAILURE' =
	'OPTIONAL_PROGRAM_ITEM/REQUEST_CREATE_CUSTOM_FAILURE';
